// src/sections/Footer.js
import React, { useMemo } from "react";
import "./Footer.css";

export default function Footer({ logoWhiteSrc }) {
  const year = useMemo(() => new Date().getFullYear(), []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="footer" aria-label="Footer">
      <div className="footer__wrap">
        <div className="footer__top">
          <button
            className="footer__brand"
            type="button"
            onClick={() => scrollTo("projects")}
            aria-label="Back to top"
          >
            <div className="footer__brandText">
              {logoWhiteSrc ? (
              <img className="footer__logo" src={logoWhiteSrc} alt="Logo" />
            ) : (
              <div className="footer__logoFallback">PR</div>
            )}
              <div className="footer__role">Software • Cloud • Product</div>
            </div>
          </button>

          <div className="footer__links" aria-label="Footer navigation">
            <button className="footer__link" type="button" onClick={() => scrollTo("projects")}>
              Projects
            </button>
            <button className="footer__link" type="button" onClick={() => scrollTo("about")}>
              About
            </button>
            <button className="footer__link" type="button" onClick={() => scrollTo("contact")}>
              Contact
            </button>
          </div>
        </div>

        <div className="footer__divider" aria-hidden="true" />

        <div className="footer__bottom">
          <div className="footer__meta">
            © {year} Patrick Riachi. All rights reserved.
          </div>

          <div className="footer__social" aria-label="Social links">
            {/* Replace href with your profiles */}
            <a className="footer__socialLink" href="https://www.linkedin.com" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
            <a className="footer__socialLink" href="https://github.com" target="_blank" rel="noreferrer">
              GitHub
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
